// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 576px) {
}
@media (min-width: 768px) {
 
}
@media (min-width: 992px) {

}
@media (min-width: 1569.98px) {
}
@media (max-width: 1569.98px) {
  
}
@media (max-width: 1350.98px) {
 
}
@media (max-width: 1250.98px) {
    button.ant-btn.fill-btn { 
        min-width: 150px; 
    }
    button.ant-btn.outline-btn { 
        min-width: 110px; 
    }
}
@media (max-width: 1199.98px) {
    .feature-grid {
        gap: 20px;
    }
    .feature-grid-card {
        padding: 10px;
    }
    section.features-grid-section , section.plan-section , section.hero-section{
        padding: 70px 0px;
    }
    .trandings-insite { 
        padding: 0px 10px;
    }
}
 
@media (max-width: 991.98px) {
    .navbar-menu,
    .header-main .header-buttons {
      display: none !important;
    }
    .mobile-header-actions {
      display: flex;
      align-items: center;
    }
    .mobile-login-bar {
      display: flex;
      gap: 10px;
      background: #F2F8FF;
      padding: 0 10px 12px;
    }
    .mobile-login-bar .fill-btn,
    .mobile-login-bar .outline-btn {
      flex: 1 1;
      white-space: nowrap;
    }
    .logo-image img {
        max-width: 50px;
        width: 100%;
    }
    nav.header-main { 
        padding: 8px 10px; 
    }
    h1.hero-title {
        font-size: 34px;
        line-height: 1.3;
    }
    section.plan-section , section.features-grid-section{
        padding: 50px 0px 50px;
    }
    section.hero-section {
        padding: 50px 0px 50px;
    }
    section.hero-section .hero-banner-shape{
        display: none;
    }
    .feature-grid {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: none;
    }
    .feature-grid-card.bento-lg,
    .feature-grid-card.bento-sm,
    .feature-grid-card.bento-wide {
        grid-column: span 1;
        grid-row: span 1;
    }
    .scroll-story {
        grid-template-columns: 1fr;
        gap: 0;
        padding: 0 4%;
    }
    /* Hide the shared sticky visual on mobile — each step shows its own screenshot */
    .scroll-story-visual {
        display: none;
    }
    .scroll-story-text {
        gap: 40px;
        padding: 0;
    }
    /* Show per-step inline screenshot on mobile */
    .scroll-story-step-shot {
        display: block;
        margin-top: 20px;
    }
    /* All steps fully visible on mobile — no fade */
    .scroll-story-step {
        opacity: 1 !important;
    }
    .feature-tabs .ant-tabs-tab {
        padding: 10px 10px !important;
    }
    .features-container{
        flex-wrap: wrap;
        margin-top: 50px;
    }
    h4.section-title , h2.section-title{
        font-size: 28px;
        line-height: 1.3;
        margin-bottom: 20px;
    }
    .plan-header h6.subtitle { 
        font-size: 16px; 
    }
    .section-header {
        margin-bottom: 50px;
    }
    .feature-icon-container {
        margin-bottom: 16px;
    }
    .faq-container { 
        padding: 30px 30px; 
    }
    .faq-headding h6.section-title { 
        font-size: 16px;
        margin-bottom: 5px; 
    }
    .faq-headding p { 
        font-size: 14px;
        line-height: 1.4; 
    }
    .ant-collapse-header { 
        font-size: 15px; 
    }
    section.faq-section {
        margin-bottom: 120px;
    }
    h2.newsletter-title {
        font-size: 28px;
        line-height: 1.4;
        white-space: normal;
    }
    p.newsletter-desc { 
        font-size: 14px;
        line-height: 22px; 
        max-width: 750px; 
    }
    .newslatter-input { 
        margin: 30px auto 0px; 
    }
    button.ant-btn.subcribe-btn { 
        font-weight: 500;
        font-size: 16px; 
    }
    .footer-header { 
        padding-bottom: 20px; 
        margin-bottom: 15px;
    }
    footer.footer-section { 
        padding: 180px 0px 30px;
    }
    .footer-dics p { 
        font-size: 14px;
        line-height: 26px; 
    }
    .footer-bootamline { 
        gap: 8px; 
    }
    h2.faq-subtitle {
        font-size: 28px;
        line-height: 1.3;
    }
    .trandings-insite {
        max-width: 205px; 
        padding: 0px 10px;
    }
    .tranding-headding { 
        width: 100%;
        text-align: center;
    }


}
@media (max-width: 767.98px) {
    section.features-grid-section h2.section-title {
        white-space: normal;
        font-size: 26px;
    }
    .public-blog-page {
        padding: 38px 0 64px;
    }
    .public-blog-article {
        padding: 30px 22px 42px;
    }
    .public-blog-article h1 {
        font-size: 32px;
    }
    .public-blog-content {
        font-size: 16px;
    }
    .faq-container {
        padding: 20px;
        border-radius: 15px;
    }
}
@media (max-width: 575.98px) {
    .section-header {
        margin-bottom: 20px;
    }
    .feature-tabs .ant-tabs-tab {
        padding: 10px 4px !important;
        border-radius: 5px;
    }
    .ant-tabs.feature-tabs .ant-tabs-tab+.ant-tabs-tab {
        margin: 0 0 0 8px;
    }
    .feature-tabs .ant-tabs-tab-btn { 
        font-size: 13px; 
    }
    button.ant-btn.trial-btn , button.ant-btn.demo-btn{ 
        font-weight: 500;
        font-size: 14px; 
    }
    p.hero-subtitle {
        font-size: 16px;
        letter-spacing: 0;
    }
    h1.hero-title {
        font-size: 25px;
    }

    h4.section-title, h2.section-title {
        font-size: 22px; 
    }
    a.footer-social-btn img{
        width: 20px;
    }
    a.footer-social-btn {
        width: 35px;
        height: 35px; 
        font-size: 12px; 
    }
    .social-bar-icons { 
        gap: 8px; 
    }
    button.ant-btn.subcribe-btn {
        font-weight: 500;
        font-size: 13px;
        padding: 10px;
    }
    h2.newsletter-title {
        font-size: 22px;
    }
    .mail-icon-wrapper {
        width: 70px;
        height: 70px;
        margin: -86px auto 14px;
    }
    .mail-icon-wrapper svg {
        width: 28px;
        height: 28px;
    }
    section.faq-section {
        margin-bottom: 90px;
    }
    .ant-collapse-header {
        font-size: 13px;
        line-height: 1.3 !important;
        padding: 5px !important;
    } 
    .ant-collapse .ant-collapse-content>.ant-collapse-content-box {
        padding: 6px 9px;
        font-size: 12px;
    }  
    h2.faq-subtitle {
        font-size: 18px;
    }
    .ant-collapse-item.faq-panel { 
        margin-bottom: 10px;
    }
    .trandings-insite {
        max-width: 100%;
        padding: 0px 10px;
    }
    .features-container { 
        gap: 20px; 
    }
    h6.feature-title {
        font-size: 16px;
    }
    p.feature-text {
        margin: 0;
    }
    .feature-grid {
        grid-template-columns: repeat(1, 1fr);
        gap: 10px;
    }
}
@media (max-width: 480px) {

}

@media (max-width: 991.98px) {
    .testimonials-grid { grid-template-columns: 1fr; }
    .pricing-grid { grid-template-columns: 1fr; max-width: 520px; margin-left: auto; margin-right: auto; }
    section.social-proof-section { padding: 60px 0; }
    section.pricing-section { padding: 60px 0; }
    .footer-top { flex-direction: column; gap: 40px; }
    nav.footer-nav { flex-wrap: wrap; gap: 40px; }
    .footer-brand { max-width: 100%; }
}
@media (max-width: 575.98px) {
    .stats-row { gap: 40px; }
    .stat-num { font-size: 40px; }
    .pricing-card { padding: 32px 24px; }
    .pricing-amount { font-size: 40px; }
    .scroll-to-top-btn { bottom: 20px; right: 20px; width: 40px; height: 40px; }
    h2.section-title.social-proof-title { font-size: 28px; }
    .trms-text-line { flex-wrap: wrap; gap: 12px; }
    .footer-bottom { flex-direction: column; align-items: flex-start; gap: 8px; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/responsive.css"],"names":[],"mappings":"AAAA;AACA;AACA;;AAEA;AACA;;AAEA;AACA;AACA;AACA;;AAEA;AACA;;AAEA;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,SAAS;IACb;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;;MAEE,wBAAwB;IAC1B;IACA;MACE,aAAa;MACb,mBAAmB;IACrB;IACA;MACE,aAAa;MACb,SAAS;MACT,mBAAmB;MACnB,oBAAoB;IACtB;IACA;;MAEE,SAAO;MACP,mBAAmB;IACrB;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,qCAAqC;QACrC,wBAAwB;IAC5B;IACA;;;QAGI,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,0BAA0B;QAC1B,MAAM;QACN,aAAa;IACjB;IACA,iFAAiF;IACjF;QACI,aAAa;IACjB;IACA;QACI,SAAS;QACT,UAAU;IACd;IACA,8CAA8C;IAC9C;QACI,cAAc;QACd,gBAAgB;IACpB;IACA,gDAAgD;IAChD;QACI,qBAAqB;IACzB;IACA;QACI,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,oBAAoB;QACpB,mBAAmB;IACvB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,QAAQ;IACZ;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;;;AAGJ;AACA;IACI;QACI,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;IACA;QACI,QAAQ;IACZ;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,uBAAuB;IAC3B;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,2BAA2B;QAC3B,uBAAuB;IAC3B;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,SAAS;IACb;IACA;QACI,eAAe;IACnB;IACA;QACI,SAAS;IACb;IACA;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;AACA;;AAEA;;AAEA;IACI,qBAAqB,0BAA0B,EAAE;IACjD,gBAAgB,0BAA0B,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;IACrG,+BAA+B,eAAe,EAAE;IAChD,0BAA0B,eAAe,EAAE;IAC3C,cAAc,sBAAsB,EAAE,SAAS,EAAE;IACjD,iBAAiB,eAAe,EAAE,SAAS,EAAE;IAC7C,gBAAgB,eAAe,EAAE;AACrC;AACA;IACI,aAAa,SAAS,EAAE;IACxB,YAAY,eAAe,EAAE;IAC7B,gBAAgB,kBAAkB,EAAE;IACpC,kBAAkB,eAAe,EAAE;IACnC,qBAAqB,YAAY,EAAE,WAAW,EAAE,WAAW,EAAE,YAAY,EAAE;IAC3E,sCAAsC,eAAe,EAAE;IACvD,kBAAkB,eAAe,EAAE,SAAS,EAAE;IAC9C,iBAAiB,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAChF","sourcesContent":["@media (min-width: 576px) {\n}\n@media (min-width: 768px) {\n \n}\n@media (min-width: 992px) {\n\n}\n@media (min-width: 1569.98px) {\n}\n@media (max-width: 1569.98px) {\n  \n}\n@media (max-width: 1350.98px) {\n \n}\n@media (max-width: 1250.98px) {\n    button.ant-btn.fill-btn { \n        min-width: 150px; \n    }\n    button.ant-btn.outline-btn { \n        min-width: 110px; \n    }\n}\n@media (max-width: 1199.98px) {\n    .feature-grid {\n        gap: 20px;\n    }\n    .feature-grid-card {\n        padding: 10px;\n    }\n    section.features-grid-section , section.plan-section , section.hero-section{\n        padding: 70px 0px;\n    }\n    .trandings-insite { \n        padding: 0px 10px;\n    }\n}\n \n@media (max-width: 991.98px) {\n    .navbar-menu,\n    .header-main .header-buttons {\n      display: none !important;\n    }\n    .mobile-header-actions {\n      display: flex;\n      align-items: center;\n    }\n    .mobile-login-bar {\n      display: flex;\n      gap: 10px;\n      background: #F2F8FF;\n      padding: 0 10px 12px;\n    }\n    .mobile-login-bar .fill-btn,\n    .mobile-login-bar .outline-btn {\n      flex: 1;\n      white-space: nowrap;\n    }\n    .logo-image img {\n        max-width: 50px;\n        width: 100%;\n    }\n    nav.header-main { \n        padding: 8px 10px; \n    }\n    h1.hero-title {\n        font-size: 34px;\n        line-height: 1.3;\n    }\n    section.plan-section , section.features-grid-section{\n        padding: 50px 0px 50px;\n    }\n    section.hero-section {\n        padding: 50px 0px 50px;\n    }\n    section.hero-section .hero-banner-shape{\n        display: none;\n    }\n    .feature-grid {\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-rows: none;\n    }\n    .feature-grid-card.bento-lg,\n    .feature-grid-card.bento-sm,\n    .feature-grid-card.bento-wide {\n        grid-column: span 1;\n        grid-row: span 1;\n    }\n    .scroll-story {\n        grid-template-columns: 1fr;\n        gap: 0;\n        padding: 0 4%;\n    }\n    /* Hide the shared sticky visual on mobile — each step shows its own screenshot */\n    .scroll-story-visual {\n        display: none;\n    }\n    .scroll-story-text {\n        gap: 40px;\n        padding: 0;\n    }\n    /* Show per-step inline screenshot on mobile */\n    .scroll-story-step-shot {\n        display: block;\n        margin-top: 20px;\n    }\n    /* All steps fully visible on mobile — no fade */\n    .scroll-story-step {\n        opacity: 1 !important;\n    }\n    .feature-tabs .ant-tabs-tab {\n        padding: 10px 10px !important;\n    }\n    .features-container{\n        flex-wrap: wrap;\n        margin-top: 50px;\n    }\n    h4.section-title , h2.section-title{\n        font-size: 28px;\n        line-height: 1.3;\n        margin-bottom: 20px;\n    }\n    .plan-header h6.subtitle { \n        font-size: 16px; \n    }\n    .section-header {\n        margin-bottom: 50px;\n    }\n    .feature-icon-container {\n        margin-bottom: 16px;\n    }\n    .faq-container { \n        padding: 30px 30px; \n    }\n    .faq-headding h6.section-title { \n        font-size: 16px;\n        margin-bottom: 5px; \n    }\n    .faq-headding p { \n        font-size: 14px;\n        line-height: 1.4; \n    }\n    .ant-collapse-header { \n        font-size: 15px; \n    }\n    section.faq-section {\n        margin-bottom: 120px;\n    }\n    h2.newsletter-title {\n        font-size: 28px;\n        line-height: 1.4;\n        white-space: normal;\n    }\n    p.newsletter-desc { \n        font-size: 14px;\n        line-height: 22px; \n        max-width: 750px; \n    }\n    .newslatter-input { \n        margin: 30px auto 0px; \n    }\n    button.ant-btn.subcribe-btn { \n        font-weight: 500;\n        font-size: 16px; \n    }\n    .footer-header { \n        padding-bottom: 20px; \n        margin-bottom: 15px;\n    }\n    footer.footer-section { \n        padding: 180px 0px 30px;\n    }\n    .footer-dics p { \n        font-size: 14px;\n        line-height: 26px; \n    }\n    .footer-bootamline { \n        gap: 8px; \n    }\n    h2.faq-subtitle {\n        font-size: 28px;\n        line-height: 1.3;\n    }\n    .trandings-insite {\n        max-width: 205px; \n        padding: 0px 10px;\n    }\n    .tranding-headding { \n        width: 100%;\n        text-align: center;\n    }\n\n\n}\n@media (max-width: 767.98px) {\n    section.features-grid-section h2.section-title {\n        white-space: normal;\n        font-size: 26px;\n    }\n    .public-blog-page {\n        padding: 38px 0 64px;\n    }\n    .public-blog-article {\n        padding: 30px 22px 42px;\n    }\n    .public-blog-article h1 {\n        font-size: 32px;\n    }\n    .public-blog-content {\n        font-size: 16px;\n    }\n    .faq-container {\n        padding: 20px;\n        border-radius: 15px;\n    }\n}\n@media (max-width: 575.98px) {\n    .section-header {\n        margin-bottom: 20px;\n    }\n    .feature-tabs .ant-tabs-tab {\n        padding: 10px 4px !important;\n        border-radius: 5px;\n    }\n    .ant-tabs.feature-tabs .ant-tabs-tab+.ant-tabs-tab {\n        margin: 0 0 0 8px;\n    }\n    .feature-tabs .ant-tabs-tab-btn { \n        font-size: 13px; \n    }\n    button.ant-btn.trial-btn , button.ant-btn.demo-btn{ \n        font-weight: 500;\n        font-size: 14px; \n    }\n    p.hero-subtitle {\n        font-size: 16px;\n        letter-spacing: 0;\n    }\n    h1.hero-title {\n        font-size: 25px;\n    }\n\n    h4.section-title, h2.section-title {\n        font-size: 22px; \n    }\n    a.footer-social-btn img{\n        width: 20px;\n    }\n    a.footer-social-btn {\n        width: 35px;\n        height: 35px; \n        font-size: 12px; \n    }\n    .social-bar-icons { \n        gap: 8px; \n    }\n    button.ant-btn.subcribe-btn {\n        font-weight: 500;\n        font-size: 13px;\n        padding: 10px;\n    }\n    h2.newsletter-title {\n        font-size: 22px;\n    }\n    .mail-icon-wrapper {\n        width: 70px;\n        height: 70px;\n        margin: -86px auto 14px;\n    }\n    .mail-icon-wrapper svg {\n        width: 28px;\n        height: 28px;\n    }\n    section.faq-section {\n        margin-bottom: 90px;\n    }\n    .ant-collapse-header {\n        font-size: 13px;\n        line-height: 1.3 !important;\n        padding: 5px !important;\n    } \n    .ant-collapse .ant-collapse-content>.ant-collapse-content-box {\n        padding: 6px 9px;\n        font-size: 12px;\n    }  \n    h2.faq-subtitle {\n        font-size: 18px;\n    }\n    .ant-collapse-item.faq-panel { \n        margin-bottom: 10px;\n    }\n    .trandings-insite {\n        max-width: 100%;\n        padding: 0px 10px;\n    }\n    .features-container { \n        gap: 20px; \n    }\n    h6.feature-title {\n        font-size: 16px;\n    }\n    p.feature-text {\n        margin: 0;\n    }\n    .feature-grid {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 10px;\n    }\n}\n@media (max-width: 480px) {\n\n}\n\n@media (max-width: 991.98px) {\n    .testimonials-grid { grid-template-columns: 1fr; }\n    .pricing-grid { grid-template-columns: 1fr; max-width: 520px; margin-left: auto; margin-right: auto; }\n    section.social-proof-section { padding: 60px 0; }\n    section.pricing-section { padding: 60px 0; }\n    .footer-top { flex-direction: column; gap: 40px; }\n    nav.footer-nav { flex-wrap: wrap; gap: 40px; }\n    .footer-brand { max-width: 100%; }\n}\n@media (max-width: 575.98px) {\n    .stats-row { gap: 40px; }\n    .stat-num { font-size: 40px; }\n    .pricing-card { padding: 32px 24px; }\n    .pricing-amount { font-size: 40px; }\n    .scroll-to-top-btn { bottom: 20px; right: 20px; width: 40px; height: 40px; }\n    h2.section-title.social-proof-title { font-size: 28px; }\n    .trms-text-line { flex-wrap: wrap; gap: 12px; }\n    .footer-bottom { flex-direction: column; align-items: flex-start; gap: 8px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
